// components
import { Typography } from '@mui/material';
import { Icon } from '@sdb/planning-ui';

// hooks
import { useTranslation } from 'react-i18next';

// styles
import { IconContainer } from 'components/shared/Header/Header.styles';
import { StyledChangesAfterPublicationPlaceholderBox } from './ChangesAfterPublicationPlaceholder.styles';

// utils
import theme from 'config/theme';

/**
 * Stands in for the changes after publication overview, which replaces both grids in that mode and
 * arrives with feature 7 of #2498. Says so rather than leaving an empty area, so choosing the mode
 * does not look like a screen that failed to load.
 */
const ChangesAfterPublicationPlaceholder = () => {
  'use memo';

  const { t } = useTranslation('common', {
    keyPrefix: 'rosterPlan.mode.changesAfterPublicationUnavailable'
  });

  return (
    <StyledChangesAfterPublicationPlaceholderBox>
      <IconContainer iconSize="LARGE" iconColor={theme.palette.primary.main}>
        <Icon type="clock-rotate-left" color="inherit" />
      </IconContainer>
      <Typography component="h2" variant="h6">
        {t('title')}
      </Typography>
      <Typography component="p" variant="body1">
        {t('description')}
      </Typography>
    </StyledChangesAfterPublicationPlaceholderBox>
  );
};

export default ChangesAfterPublicationPlaceholder;
